<template>
    <div class="d-flex flex-column align-items-start">
        <div v-if="isAnotherGateway" class="d-flex flex-column stripe-gap">
            <span
                >If another payment gateway is configured and you wish to connect with Stripe, please set payment
                gateway to None first.</span
            >
            <b>Warning: this action will cause you to lose any existing credit card data.</b>
        </div>
        <b-button :href="stripeUrl" v-else-if="isGatewayNone" variant="primary"
            ><font-awesome-icon class="mr-2" :icon="['fab', 'stripe']" />Connect With Stripe</b-button
        >
        <div v-else-if="isStripeGateway && !isStripeUpgraded" class="d-flex flex-column stripe-gap align-items-start">
            <span>Please press the button below to upgrade to Stripe Connect.</span>

            <span>Stripe has a new, more secure connection available. It is very simpleand takes just seconds.</span>

            <span>Please login to Stripe.com BEFORE upgrading your account.</span>

            <span
                >1) If you have multiple Stripe.com accounts, it is very important to double check that you are logged
                into the correct Stripe account. Connecting Lodgix to an incorrect Stripe.com account will cause the
                loss of all stored guest credit card data.
            </span>

            <span
                >2) If the message "Disabling your payment gateway is a BIG deal ..." is displayed, please cancel the
                upgrade and contact support to avoid data loss.</span
            >

            <a
                class="link"
                href="http://docs.lodgix.com/m/5502/l/1029249-upgrading-to-stripe-com-connect"
                target="_blank"
                >Upgrade instructions</a
            >
            <b-button :href="stripeUrl" variant="primary"> Upgrade to Stripe Connect</b-button>
        </div>
        <div v-else-if="isStripeUpgraded && !isAnotherGateway" class="d-flex flex-column stripe-gap align-items-start">
            <span class="font-weight-bold d-block mb-3">You are now connected to Stripe.</span>
            <span> Press button below to authenticate again with the same Stripe account. </span>
            <span class="font-weight-bold">Only necessary if Stripe authentication is not working.</span>
            <b-button :href="stripeUrl" class="mt-2 mb-4" variant="primary"> Reconnect to Stripe</b-button>
            <span> To disconnect from Stripe or to change Stripe account, please set gateway to None.</span>
            <span> <b>Warning: this action will cause you to lose any existing credit card data.</b></span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { NONE_ID } from '../utils';
import { paymentComponentMixin } from './mixin';

export default {
    name: 'StripeEdit',
    mixins: [paymentComponentMixin],
    computed: {
        ...mapGetters('paymentGateway', ['originalPaymentGatewayData']),
        isGatewayNone() {
            return this.originalPaymentGatewayData && this.originalPaymentGatewayData.gateway.id === NONE_ID;
        },
        isStripeGateway() {
            return (
                this.originalPaymentGatewayData &&
                this.originalPaymentGatewayData.gateway.name.toLowerCase() === 'stripe'
            );
        },
        isStripeUpgraded() {
            return this.isStripeGateway && this.originalPaymentGatewayData.stripe_connect_upgrade?.upgraded;
        },
        isAnotherGateway() {
            return (
                this.originalPaymentGatewayData &&
                !['none', 'stripe'].includes(this.originalPaymentGatewayData.gateway.name.toLowerCase())
            );
        },
        stripeUrl() {
            return (
                this.originalPaymentGatewayData &&
                [
                    'https://connect.stripe.com/oauth/authorize?',
                    'response_type=',
                    'code',
                    '&client_id=',
                    this.originalPaymentGatewayData.stripe_client_id,
                    '&redirect_uri=',
                    encodeURIComponent(this.originalPaymentGatewayData.stripe_redirect_url),
                    '&scope=',
                    'read_write',
                    '&state=',
                    this.originalPaymentGatewayData.stripe_connect_hash,
                ].join('')
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.stripe-gap {
    gap: 1rem;
}
</style>